import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, JsonpModule} from '@angular/http';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import {FlashMessagesModule} from 'angular2-flash-messages';
import {AppComponent} from './app.component';

// import {RouterModule}   from '@angular/router';
import {AppRoutingModule} from './app-routing.module';

import {InicioComponent} from './inicio/inicio.component';
import {InscricaoComponent} from './inscricao/inscricao.component';
import {EventoComponent} from './evento/evento.component';
import {EventosComponent} from './eventos/eventos.component';
import {UsuarioComponent} from './usuario/usuario.component';
import {AcessoComponent} from './acesso/acesso.component';
import {CadastroComponent} from './cadastro/cadastro.component';
import {TrabalhoComponent} from './trabalho/trabalho.component';

import { TextMaskModule } from 'angular2-text-mask';
import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';
import { NovaSenhaComponent } from './nova-senha/nova-senha.component';
import { AdminComponent } from './admin/admin.component';

import { AvaliacaoListComponent } from './avaliacao-list/avaliacao-list.component';
import { AvaliacaoDetailComponent } from './avaliacao-detail/avaliacao-detail.component';
import {AvaliacaoComponent} from "./avaliacao/avaliacao.component";

import { TrabalhoListComponent } from './trabalho-list/trabalho-list.component';
import { InscricaoListComponent } from './inscricao-list/inscricao-list.component';
import { InscricaoDetailComponent } from './inscricao-detail/inscricao-detail.component';
import { UsuarioDetailComponent } from './usuario-detail/usuario-detail.component';

import {TagInputModule} from 'ngx-chips';
import { TrabalhoDetailComponent } from "./trabalho-detail/trabalho-detail.component";
import { AutoresComponent } from './autores/autores.component';
import { FileUploadModule } from 'ng2-file-upload';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { Utils } from './shared/utils';
import { UsuarioListComponent } from './usuario-list/usuario-list.component';
import { PerfilComponent } from './perfil/perfil.component';
import { PerfilListComponent } from './perfil-list/perfil-list.component';
import { PerfilDetailComponent } from './perfil-detail/perfil-detail.component';
import { EventoDetailComponent } from './evento-detail/evento-detail.component';
import { EventoListComponent } from './evento-list/evento-list.component';
import { TableComponent } from './table/table.component';
import { SearchComponent } from './search/search.component';
import { TrabalhoEditComponent } from './trabalho-edit/trabalho-edit.component';
import { ReportComponent } from './report/report.component';
import { ReportListComponent } from './report-list/report-list.component';
import { ReportDetailComponent } from './report-detail/report-detail.component';
import {ReportAccessComponent} from './report-access/report-access.component';
import { InscricoesUsuariosListComponent } from './inscricoes-usuarios-list/inscricoes-usuarios-list.component';
import { InscricaoEditComponent } from './inscricao-edit/inscricao-edit.component';
import {Ng4LoadingSpinnerModule} from 'ng4-loading-spinner';
import {ConfigComponent} from './config/config.component';
import { PedirRecursoComponent } from './pedir-recurso/pedir-recurso.component';
import { EncaminharRecursoComponent } from './encaminhar-recurso/encaminhar-recurso.component';
import { AvaliarRecursoComponent } from './avaliar-recurso/avaliar-recurso.component';
import { AvaliarRecursoListComponent } from './avaliar-recurso-list/avaliar-recurso-list.component';
import { MyDatePickerModule } from 'mydatepicker';
import { CertificadoComponent } from './certificado/certificado.component';
import { PenalidadeComponent } from './penalidade/penalidade.component';
import { PenalidadeListComponent } from './penalidade-list/penalidade-list.component';

@NgModule({
    declarations: [
        AppComponent,
        InicioComponent,
        InscricaoComponent,
        EventoComponent,
        EventosComponent,
        UsuarioComponent,
        AcessoComponent,
        CadastroComponent,
        TrabalhoComponent,
        RecuperarSenhaComponent,
        NovaSenhaComponent,
        AvaliacaoListComponent,
        AvaliacaoDetailComponent,
        AdminComponent,
        TrabalhoListComponent,
        InscricaoListComponent,
        InscricaoDetailComponent,
        UsuarioDetailComponent,
        TrabalhoDetailComponent,
        AutoresComponent,
        AvaliacaoComponent,
        UsuarioListComponent,
        PerfilComponent,
        PerfilListComponent,
        PerfilDetailComponent,
        EventoDetailComponent,
        EventoListComponent,
        TableComponent,
        SearchComponent,
        TrabalhoEditComponent,
        ReportComponent,
        ReportListComponent,
        ReportDetailComponent,
        InscricoesUsuariosListComponent,
        InscricaoEditComponent,
        ReportAccessComponent,
        ConfigComponent,
        PedirRecursoComponent,
        EncaminharRecursoComponent,
        AvaliarRecursoComponent,
        AvaliarRecursoListComponent,
        CertificadoComponent,
		PenalidadeComponent,
		PenalidadeListComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        JsonpModule,
        ToastModule,
        FlashMessagesModule,
        AppRoutingModule,
        TextMaskModule,
        TagInputModule,
        FileUploadModule,
		Ng4LoadingSpinnerModule,
		BrowserAnimationsModule,
		MyDatePickerModule
    ],
    providers: [
      Utils
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts